export default {
  "path": "/demo/container-index",
  "meta": {
    "name": "demo-详情容器",
    "title": "Container 详情容器",
    "isComponentDoc": true,
    "category": "Data"
  }
};